import React from 'react';
import {
  FAModal,
  FlexWrapper,
  Header,
  Price,
  WrapperDiv,
  DateSpan,
  SubHeading,
  Wrapper
} from './styles';
import DonutChart from '../InvestmentChart/InvestmentChart';
import TooltipComponent from '../../../../CommonComponents/Info/Tooltip/TooltipComponent';
import { amountFormatter, dateFormatter } from '../../utils';
import PropTypes from 'prop-types';

const bodyHeightFind = () => {
  if (window.innerWidth === 768 && window.innerHeight === 1024) {
    return 479;
  } else {
    return window.innerHeight - (153 + 91);
  }
};

function Popup(props) {
  return (
    props.popupData && (
      <FAModal
        title={
          props.popupData.accountName + '-' + props.popupData.accountNumber
        }
        visible={true}
        style={window.innerWidth > 767 ? { top: 50 } : { top: 20 }}
        onCancel={props.cancelModal}
        bodyHeight={bodyHeightFind()}
        width={
          window.innerWidth >= 767
            ? window.innerWidth >= 1024
              ? 955
              : 650
            : '100%'
        }
        cancelText='CLOSE'
      >
        <FlexWrapper>
          <WrapperDiv Short>
            <Header data-test='balance-text'>
              Current Balance
              <TooltipComponent
                placement='bottom'
                text="Balance in your donor-advised fund after the previous day's trading cycle is complete"
              />
            </Header>
            <Price data-test="current-balance">{amountFormatter(props.popupData.currentBalance)}</Price>
          </WrapperDiv>
          <WrapperDiv Long>
            <Header data-test='balance-text'>Grants YTD</Header>
            <Price data-test="amount-ytd">{amountFormatter(props.popupData.ytd.grantsYtd)}</Price>
            <DateSpan>
              Last Grant on
              <br />
              {dateFormatter(props.popupData.lastGrantDate)}
            </DateSpan>
          </WrapperDiv>
          <WrapperDiv>
            <Header data-test='balance-text'>Contributions YTD</Header>
            <Price data-test="amount-ytd">
              {amountFormatter(props.popupData.ytd.contributionYtd)}
            </Price>
            <DateSpan>
              Last Contribution on
              <br /> {dateFormatter(props.popupData.lastContributionDate)}
            </DateSpan>
          </WrapperDiv>
        </FlexWrapper>
        <Wrapper className='financial-advisor'>
          <SubHeading noWeight data-test='allocation-text'>Investment Allocation</SubHeading>
          <DateSpan>
            Last Exchange on <br />{' '}
            {dateFormatter(props.popupData.lastExchangeDate)}
          </DateSpan>
          <DonutChart
            data={props.data}
            chartNames={props.chartNames}
            errorMessage={props.errorMessage}
          />
        </Wrapper>
      </FAModal>
    )
  );
}

export default Popup;

Popup.propTypes = {
  cancelModal:PropTypes.func.isRequired,
  chartNames:PropTypes.arrayOf(PropTypes.array).isRequired,
  data:PropTypes.arrayOf(PropTypes.array).isRequired,
  errorMessage:PropTypes.string,
  faDetailCardData: PropTypes.arrayOf(
    PropTypes.shape({
      accountName: PropTypes.string.isRequired,
      accountNumber: PropTypes.string.isRequired,
      clientFirstName: PropTypes.string,
      clientLasttName: PropTypes.string,
      clientMiddleName: PropTypes.string,
      clientPrefix: PropTypes.string,
      clientSuffix: PropTypes.string,
      currentBalance: PropTypes.number,
      dateOpened: PropTypes.number,
      investmentAllocation: PropTypes.object,
      lastContributionDate: PropTypes.number,
      lastExchangeDate: PropTypes.number,
      lastGrantDate: PropTypes.number,
      pendingContribution: PropTypes.bool,
      pendingExchange: PropTypes.bool,
      pendingGrant: PropTypes.bool,
      role: PropTypes.string,
      saFirstName: PropTypes.string,
      saLastName: PropTypes.string,
      saMiddleName: PropTypes.string,
      saPrefix: PropTypes.string,
      saSuffix: PropTypes.string,
      state: PropTypes.string,
      ytd: PropTypes.object,
    })
  ),
}